import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  buildWorkflowEditorPanelShellProps,
  resolveWorkflowEditorLayout,
} from '../utils/workflowBuilderLayout';

export function useWorkflowEditorLayout(editorFlags = {}) {
  const [builderNode, setBuilderNode] = useState(null);
  const [builderWidth, setBuilderWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200,
  );
  const [viewportWidth, setViewportWidth] = useState(builderWidth);

  const builderRef = useCallback((node) => {
    setBuilderNode(node);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const updateViewport = () => setViewportWidth(window.innerWidth);
    updateViewport();
    window.addEventListener('resize', updateViewport);
    return () => window.removeEventListener('resize', updateViewport);
  }, []);

  useEffect(() => {
    if (!builderNode || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(([entry]) => {
      if (entry) setBuilderWidth(entry.contentRect.width);
    });
    observer.observe(builderNode);
    setBuilderWidth(builderNode.getBoundingClientRect().width);

    return () => observer.disconnect();
  }, [builderNode]);

  const layout = useMemo(
    () => resolveWorkflowEditorLayout({
      ...editorFlags,
      builderWidth,
      viewportWidth,
    }),
    [editorFlags, builderWidth, viewportWidth],
  );

  const getPanelShellProps = useCallback(
    (activePanelType, options = {}) => buildWorkflowEditorPanelShellProps(layout, activePanelType, options),
    [layout],
  );

  return {
    builderRef,
    builderWidth,
    viewportWidth,
    ...layout,
    getPanelShellProps,
  };
}

export { buildWorkflowEditorPanelShellProps };
export default useWorkflowEditorLayout;
